import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirditempotraveller() {



  const cardData =
  {
    keyword: 'Pune to Shirdi Tempo Traveller On Rent ',
    heading: 'Sanavi Travels: Pune to Shirdi Tempo Traveller On Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Shirdi Tempo Traveller on Rent, providing safe, comfortable, and hassle-free group travel for families, pilgrims, corporate groups, and tour organizers visiting the holy town of Shirdi. Our well-maintained fleet of 9, 12, 13, 17, and 20 seater tempo travellers is ideal for pilgrimage tours, weekend trips, and group journeys from Pune to Shirdi, ensuring spacious seating, air-conditioned comfort, and ample luggage space. With experienced chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth and timely journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to safe drop-off in Shirdi, Sanavi Travels provides trusted Pune to Shirdi Tempo Traveller rental services for travelers seeking comfort, safety, and a reliable pilgrimage travel experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


    "topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The Shirdi Sai Baba Temple is one of India’s most revered pilgrimage sites, dedicated to the saint Sai Baba, who preached love, faith, and patience. Millions of devotees from across the world visit the temple every year to seek blessings and spiritual peace. The beautifully maintained temple complex includes the Samadhi Mandir, Dwarkamai Mosque, and Chavadi. Daily rituals like Kakad Aarti, Shej Aarti, and Abhishek create a deeply spiritual atmosphere. The temple stands as the spiritual heart of Shirdi and a symbol of unity beyond religion."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is a sacred mosque where Sai Baba spent a significant part of his life. It houses the sacred Dhuni (holy fire) that has been continuously burning since Sai Baba’s time. Devotees believe the ashes from the Dhuni possess healing powers. The mosque also displays Sai Baba’s portrait, grinding stone, and sacred belongings. Dwarkamai is a place of deep devotion, faith, and miracles, drawing devotees seeking solace and divine grace."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi holds great religious importance as the place where Sai Baba used to rest every alternate night during the later years of his life. Today, it is an integral part of Shirdi’s spiritual circuit. Sacred rituals, including processions of Sai Baba’s palanquin, are associated with this site. Chavadi also preserves Baba’s wooden bed, oil lamp, and ceremonial items. It represents simplicity, humility, and the disciplined lifestyle followed by Sai Baba."
  },
  {
    "title": "Samadhi Mandir",
    "description": "Samadhi Mandir is the final resting place of Sai Baba and the main shrine within the temple complex. The marble idol of Sai Baba seated in a meditative posture radiates peace and compassion. The mandir witnesses thousands of devotees daily who offer prayers, flowers, and offerings. The surrounding halls and prayer areas provide a calm and sacred environment. Samadhi Mandir stands as the ultimate spiritual destination in Shirdi, symbolizing eternal presence and divine blessings."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan is believed to be the place where Sai Baba was first seen meditating under a neem tree upon arriving in Shirdi. The neem tree still stands today and is considered sacred, believed to possess healing properties. A small shrine and padukas mark the spot, making it an important place of reverence. Gurusthan represents the spiritual beginning of Sai Baba’s journey in Shirdi and holds immense devotional significance."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba often spent time in meditation and contemplation. It features the sacred Nanda Deep, a lamp that has been continuously lit since Sai Baba’s era, and the Datta Mandir. The serene pathways, trees, and benches create a tranquil environment for reflection. Lendi Baug offers devotees a quiet retreat away from the crowds, embodying Sai Baba’s teachings of simplicity and inner peace."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a theme-based devotional park that recreates scenes from Sai Baba’s life. It features life-sized statues depicting Baba’s daily activities, village life, and important moments associated with his teachings. The village setup includes huts, animals, and traditional settings, offering visitors an immersive spiritual experience. This attraction helps devotees visually connect with Sai Baba’s message of humanity, service, and compassion."
  },
  {
    "title": "Abdul Baba Cottage",
    "description": "Abdul Baba Cottage was the residence of Abdul Baba, one of Sai Baba’s closest disciples. The cottage displays rare photographs, personal belongings, and historical artifacts related to Sai Baba and his followers. It provides insight into the deep bond between Sai Baba and Abdul Baba, reflecting the saint’s message of unity beyond religion. The cottage stands as a testament to devotion, service, and spiritual harmony."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Dixit Wada Museum is a historical building within the Shirdi temple complex that preserves precious belongings of Sai Baba. Exhibits include Baba’s clothing, footwear, utensils, smoking pipes, and letters. The museum offers devotees a deeper understanding of Sai Baba’s simple lifestyle and daily routines. Dixit Wada serves as a spiritual archive, allowing visitors to feel a closer connection to Baba’s life and teachings."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds special significance as the place where Sai Baba was welcomed into Shirdi by the priest Mahalsapati with the words ‘Sai’. Dedicated to Lord Khandoba, the temple marks the spiritual arrival of Sai Baba in the village. Devotees often visit this temple before entering the Sai Baba Temple complex. It represents the beginning of Sai Baba’s divine journey in Shirdi and remains an important stop for pilgrims."
  }
],




    "services": [
    {
      "name": "Pune to Shirdi Tempo Traveller On Rent",
      "description": "Pune to Shirdi Tempo Traveller On Rent provides convenient rental options for group travel from Pune to Shirdi, ensuring comfort, safety, and reliable service."
    },
    {
      "name": "Shirdi Tempo Traveller Hire from Pune",
      "description": "Shirdi Tempo Traveller Hire from Pune offers flexible hire services for short or long trips to Shirdi with well-maintained vehicles and professional drivers."
    },
    {
      "name": "Pune Shirdi AC Tempo Traveller",
      "description": "Pune Shirdi AC Tempo Traveller offers air-conditioned vehicles for a comfortable journey from Pune to Shirdi, ideal for family and group travel."
    },
    {
      "name": "Luxury Tempo Traveller Pune to Shirdi",
      "description": "Luxury Tempo Traveller Pune to Shirdi provides premium, well-appointed vehicles for a comfortable and elegant travel experience to Shirdi."
    },
    {
      "name": "Tempo Traveller for Shirdi Darshan",
      "description": "Tempo Traveller for Shirdi Darshan is designed for devotees traveling to Shirdi, offering spacious vehicles and hassle-free group transport."
    },
    {
      "name": "Family Tempo Traveller to Shirdi",
      "description": "Family Tempo Traveller to Shirdi ensures a comfortable and safe journey for families visiting Shirdi, with ample seating and luggage space."
    },
    {
      "name": "Corporate Tempo Traveller Shirdi",
      "description": "Corporate Tempo Traveller Shirdi caters to office groups and business travelers visiting Shirdi, providing punctual and professional transport services."
    },
    {
      "name": "Affordable Pune to Shirdi Tempo Traveller",
      "description": "Affordable Pune to Shirdi Tempo Traveller offers budget-friendly rental options for groups without compromising on comfort or safety."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Shirdi",
      "description": "Chauffeur Driven Tempo Traveller Shirdi provides experienced drivers for stress-free travel from Pune to Shirdi, allowing passengers to relax during the journey."
    },
    {
      "name": "Pune Shirdi Group Travel",
      "description": "Pune Shirdi Group Travel is ideal for large groups visiting Shirdi, offering spacious vehicles and reliable service for a comfortable journey."
    },
    {
      "name": "Tempo Traveller for Sai Baba Darshan",
      "description": "Tempo Traveller for Sai Baba Darshan ensures a smooth and convenient journey for devotees traveling to Shirdi for darshan."
    },
    {
      "name": "Best Tempo Traveller Pune to Shirdi",
      "description": "Best Tempo Traveller Pune to Shirdi offers top-quality vehicles and professional service for a superior travel experience to Shirdi."
    },
    {
      "name": "Pune Shirdi Travel Bus",
      "description": "Pune Shirdi Travel Bus provides safe and comfortable bus services for group travel from Pune to Shirdi, ideal for large groups or tour operators."
    },
    {
      "name": "Tempo Traveller Rental Pune to Shirdi",
      "description": "Tempo Traveller Rental Pune to Shirdi offers reliable rental services for trips to Shirdi, ensuring comfortable seating and professional drivers."
    },
    {
      "name": "Shirdi Tour Tempo Traveller",
      "description": "Shirdi Tour Tempo Traveller provides convenient vehicles for sightseeing and group tours around Shirdi, combining comfort with reliable transport."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Tempo Traveller On Rent", "Shirdi Tempo Traveller Hire from Pune"],
    ["Pune Shirdi AC Tempo Traveller", "Luxury Tempo Traveller Pune to Shirdi"],
    ["Tempo Traveller for Shirdi Darshan", "Family Tempo Traveller to Shirdi"],
    ["Corporate Tempo Traveller Shirdi", "Affordable Pune to Shirdi Tempo Traveller"],
    ["Chauffeur Driven Tempo Traveller Shirdi", "Pune Shirdi Group Travel"],
    ["Tempo Traveller for Sai Baba Darshan", "Best Tempo Traveller Pune to Shirdi"],
    ["Pune Shirdi Travel Bus", "Tempo Traveller Rental Pune to Shirdi"],
    ["Shirdi Tour Tempo Traveller", "—"]
  ],


  "whychoose": [
  {
    "WhyChooseheading": "Pune to Shirdi Tempo Traveller on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable Pune to Shirdi Tempo Traveller on rent services, ideal for family trips, pilgrimages, group tours, and comfortable long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Tempo Travellers",
    "WhyChoosedescription": "Enjoy a comfortable journey from Pune to Shirdi in spacious, air-conditioned, and well-maintained Tempo Travellers designed for group travel."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune to Shirdi Route",
    "WhyChoosedescription": "Our professional drivers are well-experienced with the Pune to Shirdi route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Shirdi Tempo Traveller rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and trip coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized Tempo Traveller rental plans for your Pune to Shirdi journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Shirdi Tempo Traveller on rent."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Shirdi Tempo Traveller on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for Pune to Shirdi travel.'
  },
  {
    question: 'How can I book a Pune to Shirdi Tempo Traveller with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for Pune to Shirdi Tempo Traveller?',
    answer: 'We offer Tempo Travellers with various seating capacities suitable for small and large groups.'
  },
  {
    question: 'Are drivers included in the Tempo Traveller rental?',
    answer: 'Yes, all Pune to Shirdi Tempo Traveller rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the Pune to Shirdi Tempo Traveller service available 24x7?',
    answer: 'Yes, our Pune to Shirdi Tempo Traveller service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the Pune to Shirdi trip?',
    answer: 'Yes, all Tempo Travellers are cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I book a round-trip Tempo Traveller from Pune to Shirdi?',
    answer: 'Absolutely. Sanavi Travels offers one-way and round-trip Tempo Traveller rental options.'
  },
  {
    question: 'What payment options are available for Pune to Shirdi Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the Pune to Shirdi journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni',
    feedback: 'We booked a Pune to Shirdi Tempo Traveller with Sanavi Travels. Comfortable vehicle, smooth journey, and very professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Deshpande',
    feedback: 'Excellent service by Sanavi Travels. Clean Tempo Traveller and on-time pickup made our Shirdi trip peaceful.',
    rating: 5
  }
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Tempo Traveller On Rent - Sanavi Travels",
  "description": "Pune to Shirdi tempo traveller on rent by Sanavi Travels for Sai Baba darshan, family tours, corporate travel, and group trips. Choose AC and luxury tempo travellers for a comfortable and affordable Pune to Shirdi journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4321"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Shirdi Tempo Traveller On Rent Starting from ₹32 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Shirdi tempo traveller on rent with Sanavi Travels. AC and luxury tempo traveller for Sai Baba darshan, family tours, corporate and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirditempotraveller;